module.exports = __webpack_public_path__ + "img/PPMP6.f706a373.png";